export default "__VITE_ASSET__lhAtZrR3__"